module.exports = __webpack_public_path__ + "img/login-screen.59dbfc3f.webp";